module.exports = __webpack_public_path__ + "img/go-back-to-main-site.3eb9d0e7.svg";